export default __webpack_public_path__ + "static/media/NotoSans-ExtraBold.3331a161.otf";